// extracted by mini-css-extract-plugin
export default {"loadingContainer":"c0xcGFr1K","container":"ceKk4AtHS","domainsHolder":"cQjLFvvs4","selectMainDomainLink":"cc8PRpCRs","closeButton":"cZnHsWRU0","content":"cw0vXCGns"};